import styles from "./Strengths.module.css";
import { Link } from "react-router-dom";
import strengths from "data/heroStrengthData.json";
import { mapIcons } from "utils";

const mappedStrengths = strengths.map(mapIcons);

const Strengths = () => {
  return (
    <section className={styles.strengthsSection}>
      <header className={styles.textSection}>
        <div className={styles.container}>
          <p className={styles.subtitle}>Our Strengths</p>
          <h2 className={styles.sectionTitle}>Why Choose Us?</h2>

          <p className={styles.introText}>
            {/* With our advanced AI-driven automation, real-time monitoring, and compliance-first approach, 
            we ensure your credentialing and healthcare operations run smoothly, securely, and efficiently. */}
            Powered by Al-driven automation and real-time, iCredentialing supports efficient credentialing workflows while helping organizations maintain security and regulatory readiness. Contact us to learn more.
            <Link to="/contact" className={styles["contactus-link"]}>
              <strong>Contact us</strong>
            </Link>{" "}
            to learn more!
          </p>
          {/* <p className={styles.contactText}>
            <span className={styles.contactBold}>Contact us today</span> to learn how iCredentialing can 
            revolutionize your provider credentialing and healthcare compliance processes!
          </p> */}
        </div>
      </header>

      <div className={styles.container}>
        <div className={styles.strengthsGrid}>
          {mappedStrengths.map((strength, index) => (
            <article className={`${styles.strengthCard}`} key={index}>
              <div className={styles.strengthCardContent}>
                <figure className={styles.strengthIcon}>
                  <img
                    src={strength.icon}
                    className={styles.icons}
                    alt={strength.title}
                  />
                </figure>
                <h3
                  className={`${
                    strength.title === "Proactive Risk Management"
                      ? "styles.specialHeader"
                      : ""
                  }`}
                >
                  {strength.title}
                </h3>
                <div className={styles.strengthDescription}>
                  <p>{strength.description}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Strengths;
